export enum ProductIds {
    HealthEssentials = 5,
    CancerNavigator = 6,
    HealthTracker = 7,
}